import React, { useContext, useEffect, useRef, useState } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import DateForm from "../../Components/DateForm/DateForm";
import InputForm from "../../Components/InputForm/InputForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { Button, Card, Form, Image, InputGroup } from "react-bootstrap";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
// import { RiFileListLine } from "react-icons/ri";
import { DATE_DISPLAY_FORMAT } from "../../Helpers/Constants/Constants";
import moment from "moment";
import {
  SettlementRequest,
  SubmitSettlement,
  documentDetails2,
  GetReasonofRequestDropdownData,
  GetSettlementRequestDetailsByRequestID,
  SettlementDetailsById,
} from "../../Helpers/APIEndPoints/EndPoints";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { downloadBlob } from "../../Helpers/Common/BlobHelper";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import del from "../../Assets/Images/Trash icon.png";
import DescriptionIcon from "@mui/icons-material/Description";
import DeleteDialogueBox from "../../Components/DeleteDialogueBox/DeleteDialogueBox";
import "./LoanApprovalDashboard.css";
import { MODES, SPECIALCHARPATTERN } from "../../Helpers/Enums/Enum";
import SettlementStatus, {
  SettlementModule,
} from "../InternalTeamSettlementRequest/SettlementStatus";
import ImageViewer from "../../Components/ImageViewer/ImageViewer";

export function ShowAttachment(props) {
  const {
    aType,
    attachment,
    setFileToBeDeleted,
    setShowDeleteConfirmationModal,
    index,
    editMode,
    count,
  } = props;

  if (
    (aType?.startsWith("image") || aType?.includes("pdf")) &&
    (attachment?.localUrl || attachment)
  ) {
    return (
      <li className="d-flex justify-content-between align-items-center my-1">
        <div className="d-flex align-items-center">
          <Card.Text className="mb-0">
            {count}
            {". "}
            {attachment?.name || attachment?.azureFileName}
            {" "}
          </Card.Text>
        </div>
        <div>
          {!editMode && (
            <Button
              variant="outline-light"
              size="sm"
              className="deletbtn"
              onClick={() => {
                setFileToBeDeleted({
                  file: attachment,
                  index: index,
                });
                setShowDeleteConfirmationModal(true);
              }}
            >
              <Image src={del} className="delBtn" />
            </Button>
          )}
        </div>
      </li>
    );
  } else {
    return null;
  }
}

const FinalSettlement = () => {
  const context = getContext();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [tokenNumber, setTokenNumber] = useState("");
  const [memberName, setMemberName] = useState("");

  const [memberId, setMemberId] = useState();
  const [address, setAddress] = useState("");
  const [doConfirmDate, setDoConfirmDate] = useState([]);
  const [doBirth, setDoBirth] = useState([]);
  const [emailID, setEmailID] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [micrCode, setMicrCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [IFSCCode, setIFSCCode] = useState("");
  const [bankName, setBankName] = useState("");
  const [branchkName, setbranchkName] = useState("");
  const [RejectedRemarks, setRejectedRemarks] = useState("");
  const [reasonRequest, setReasonRequest] = useState<any>();
  const [isReasonDeath, setIsReasonDeath] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [error, setError] = React.useState<any>({});
  const [certificateName, setCertificateName] = useState(null);
  const [suretyModal, setSuretyModal] = useState(false);
  const [suretyData, setSuretyData] = useState<any>();

  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [isInternalTeam, setIsInternalTeam] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [submitDisable, setSubmitDisable] = useState(false);
  const [reasonArrayOptions, setreasonArrayOptions] = useState([]);
  const [loadedSettlementData, setLoadedSettlementData] = useState<any>(null);
  const [fileToBeDeleted, setFileToBeDeleted] = useState({});
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);

  const [images, setImages] = useState([]);
  const [PDFFiles, setPDFFiles] = useState([]);
  const [showImageViewer, setShowImageViewer] = useState<boolean>(false);
  const [imageIndex, setImageIndex] = useState<number>(null);
  const [documents, setDocuments] = useState([]);

  const allowedFileTypes = "png,jpeg,jpg,pdf";
  const [files, setFiles] = useState([]);
  const [fileCount, setFileCount] = useState();
  const [inputFields, setInputFields] = useState([
    {
      files: [{}],
      fileIds: [],
      fileid: [],
      uploadedFileName: "",
      attachmentFileType: "",
      thumbnailId: "",
      videoId: "",
      transcriptionData: "",
    },
  ]);
  const [checkIsUploadedFile, setCheckIsUploadedFile] = useState(false);
  const inputFileRef = useRef(null);

  
  const Id = 0;
  const [memberNumber, setMemberNumber] = useState<any>(
    context.CurrentRoleId == RoleEnum.Member ? context?.MemberNo : ""
  );
  const StateCurrentStatus = state?.currentStatus;
  const StateSetId = state?.SetId;
  const StateMemberId = state?.MemberId;
  // const StateMode = state?.mode;
  const viewmode = state?.mode === MODES.VIEW ? true : false;
  

  useEffect(() => {
    if (context.CurrentRoleId === RoleEnum.Member) {
      setIsDisable(true);
      let memNo = context.MemberNo;
      if (
        state?.SetId == 0 ||
        state?.SetId == undefined ||
        state?.SetId == null
      ) {
        getMemberDetailsById(memNo);
      } else {
        getSettlementRequestDetailsByRequestID(state?.SetId);
      }
    } else if (context.CurrentRoleId === RoleEnum.InternalTeam) {
      setIsInternalTeam(true);
      if (state?.SetId === 0) {
        setIsInternalTeam(true);
      } else {
        getSettlementRequestDetailsByRequestID(state?.SetId);
      }
    } else {
      setIsInternalTeam(false);
    }
  }, []);

  useEffect(() => {
    if (imageIndex !== null || !showImageViewer) {
      setShowImageViewer(true);
    }
  }, [imageIndex]);

  useEffect(() => {
    getReasonDropdown();
    getSettlementDetailsById();
  }, []);

  // The details and the reason dropdown load independently, so neither may depend on the
  // other having finished. Resolve the saved reason once both are available.
  useEffect(() => {
    if (!loadedSettlementData || reasonArrayOptions.length === 0) {
      return;
    }

    const selectedoption = reasonArrayOptions.find(
      (item) => item.value == loadedSettlementData.ReasonOfRequest
    );
    setReasonRequest(selectedoption);

    if (selectedoption?.label === "Death") {
      setIsReasonDeath(false);
      setIsDisable(false);
      setCertificateName(loadedSettlementData.DocumentName);
      if (loadedSettlementData.DocumentUrl) {
        Promise.resolve(downloadBlob(loadedSettlementData.DocumentUrl)).catch(
          () => {}
        );
      }
    } else {
      setIsReasonDeath(true);
      setCertificateName("");
    }
  }, [loadedSettlementData, reasonArrayOptions]);

  const getSettlementDetailsById = async () => {
    const res = await APICall(SettlementDetailsById, {
      SetId: StateSetId,
      MemberId: StateMemberId,
    });
    if (res?.Data != null) {
      setRejectedRemarks(res?.Data?.[0]?.Comment);
    }
  };

  const handleBtnClick = (e) => {
    if (inputFileRef && inputFileRef.current) {
      inputFileRef.current.click();
    }
  };

  // Never allowed to throw: this used to be awaited before the form data was fetched, so a
  // failure here left every field on the page blank.
  const getReasonDropdown = async () => {
    let options = [];
    try {
      const resp = await APICall(GetReasonofRequestDropdownData, {
        dropdownName: "Resondetails",
      });
      if (resp?.Data?.length > 0) {
        let array2 = resp.Data.map((item) => {
          return {
            value: item.Id,
            label: item.Name,
          };
        });
        options =
          context.CurrentRoleId === 2
            ? array2.filter((item) => item.label !== "Death")
            : array2;
      }
    } catch (err) {
      console.error("getReasonDropdown failed:", err);
    }
    setreasonArrayOptions(options);
    return options;
  };
  // Only FirstName was being shown; MiddleName/LastName are returned but were ignored.
  const buildFullName = (data: any) =>
    data?.FullName && String(data.FullName).trim() !== ""
      ? String(data.FullName).trim()
      : [data?.FirstName, data?.MiddleName, data?.LastName]
          .filter((part) => part && String(part).trim() !== "")
          .join(" ");

  // Only some procs return a pre-built ResidentialAddress (a CONCAT of the parts, which
  // arrives as "   ,    ,    , 400097" when unfilled). stp_GetSubmissionRequestDataByID does
  // not - it returns the raw parts via MP.*, so fall back to assembling them in the same
  // order. Blank segments are dropped instead of rendering a row of commas.
  const formatAddress = (data: any) => {
    const preBuilt = String(data?.ResidentialAddress || data?.Address || "");
    const parts =
      preBuilt.trim() !== ""
        ? preBuilt.split(",")
        : [data?.Street, data?.AddLineSecond, data?.District, data?.PostalCode];

    return parts
      .map((part) => (part == null ? "" : String(part).trim()))
      .filter((part) => part !== "")
      .join(", ");
  };

  const getMemberDetailsById = async (memberNumber1) => {
    showLoader();
    const requestData1 = {
      MemberNo: memberNumber1, // context.MemberNo :1126500
      UnitCodeIds: context.UnitCodeIds,
    };

    const res = await APICall(SettlementRequest, requestData1);
    if (res.Data && Object.keys(res.Data).length > 0) {
      setFormErrors({});
      setTokenNumber(res.Data.TokenNo);
      setMemberName(buildFullName(res.Data));
      setMemberNumber(res.Data.MemberNo);
      setMemberId(res.Data.Id);
      setAddress(formatAddress(res.Data));
      setDoConfirmDate(res.Data.DOC);
      setEmailID(res.Data.EmailId);
      setDoBirth(res.Data.DOB);
      setMobileNo(res.Data.ContactNo);
      setAccountNumber(res.Data.AccountNo);
      setMicrCode(res.Data.MICRCode);
      setBankName(res.Data.BankName);
      setbranchkName(res.Data.BankName);
      setIFSCCode(res.Data.IFSCCode);
    } else {
      setIFSCCode("");
      setMemberName("");
      setTokenNumber(" ");
      setMemberNumber("");
      setAddress("");
      setDoConfirmDate(null);
      setEmailID("");
      setDoBirth(null);
      setMobileNo("");
      setAccountNumber("");
      setMicrCode("");
      setBankName("");
      setbranchkName("");
      notify(
        ToastType.Error,
        "Member Not Found, Please Enter Valid Member Number:   " + memberNumber1
      );
      // navigate("/SettlementRequestDashboard");
    }
    hideLoader();
  };

  const getSettlementRequestDetailsByRequestID = async (SetId) => {
    const requestData1 = {
      Id: SetId, // context.MemberNo :1126500
    };

    const res = await APICall(
      GetSettlementRequestDetailsByRequestID,
      requestData1
    );
    if (res.Data && Object.keys(res.Data).length > 0) {
      setTokenNumber(res.Data.TokenNo);
      setMemberName(buildFullName(res.Data));
      setMemberNumber(res.Data.MemberNo);
      setMemberId(res.Data.Id);
      setAddress(formatAddress(res.Data));
      setDoConfirmDate(res.Data.DOC);
      setEmailID(res.Data.EmailId);
      setDoBirth(res.Data.DOB);
      setMobileNo(res.Data.ContactNo);
      setAccountNumber(res.Data.AccountNo);
      setMicrCode(res.Data.MICRCode);
      setBankName(res.Data.BankName);
      setbranchkName(res.Data.BankName);
      setIFSCCode(res.Data.IFSCCode);

      let fileNames = [];
      let fileTypes = [];
      let fileUrls = [];

      fileNames = res?.Data?.DocumentName?.split(",");
      fileTypes = res?.Data?.DocumentDetailType?.split(",");
      fileUrls = res?.Data?.DocumentUrl?.split(",");
      let newDocuments = [];
      if (fileUrls?.length > 0) {
        for (let i = 0; i < fileUrls.length; i++) {
          let fileUrl = await downloadBlob(fileUrls[i]);
          let fileType = fileTypes[i]?.toLowerCase()?.endsWith("pdf")
            ? "pdf"
            : "image";

          newDocuments.push({
            src: fileUrl,
            title: fileNames[i],
            type: fileType,
          });
        }
      }
      setDocuments(newDocuments);

      // let newImages = [];
      // let newPDFFiles = []; // Array to hold PDF files
      // if (fileUrls?.length > 0) {
      //   for (let i = 0; i < fileUrls.length; i++) {
      //     // Download blob
      //     let imgUrl = await downloadBlob(fileUrls[i]);

      //     // Determine file type
      //     let fileType = fileTypes[i]?.toLowerCase()?.endsWith("pdf")
      //       ? "pdf"
      //       : "image";

      //     // Push downloaded blob into newImages array
      //     if (fileType === "pdf") {
      //       // If the file is a PDF, push it into the newPDFFiles array
      //       newPDFFiles.push({
      //         src: imgUrl,
      //         title: fileNames[i],
      //       });
      //     } else {
      //       // Otherwise, push it into the newImages array
      //       newImages.push({
      //         src: imgUrl,
      //         title: fileNames[i],
      //       });
      //     }
      //   }
      // }

      // // Set the PDF files in state
      // setPDFFiles(newPDFFiles);

      // // Set newImages array in state
      // setImages(newImages);

      // setTokenNumber(res.Data.TokenNo);
      // setMemberName(res.Data.MemberName);
      // setMemberNumber(res.Data.MemberNo);
      // setAddress(res.Data.Address);
      // setDoConfirmDate(res.Data.DOC);
      // setEmailID(res.Data.EmailId);
      // setDoBirth(res.Data.DOB);
      // setMobileNo(res.Data.ContactNo);
      // setAccountNumber(res.Data.AccountNo);
      // setMicrCode(res.Data.MICRCode);
      // setBankName(res.Data.BankName);
      // Hand off to the effect that resolves the reason once the dropdown options arrive.
      setLoadedSettlementData(res.Data);
    } else {
      setMemberName("");
      setTokenNumber(" ");
      setMemberNumber(" ");
      setAddress("");
      setDoConfirmDate(null);
      setEmailID("");
      setDoBirth(null);
      setMobileNo("");
      setAccountNumber("");
      setMicrCode("");
      setBankName("");
      notify(
        ToastType.Error,
        "No records found for the Member Number:   " + memberNumber
      );
    }
  };

  const onSubmitValidation = () => {
    let formErrorObj = {};
    if (!reasonRequest || reasonRequest == "" || reasonRequest.length === 0) {
      formErrorObj["reasonRequest_isEmpty"] =
        "Reason of request  can not be empty";
    }
    if (certificateName == null) {
     
      formErrorObj["file_isEmpty"] = "Please upload a file";
    }

    if (IFSCCode == "" || IFSCCode === null) {
      formErrorObj["IFSCCode"] = "This field is Required";
    }
    if (accountNumber == "" || accountNumber === null) {
      formErrorObj["accountNumber"] = "This field is Required";
    }
    if (bankName == "" || bankName === null) {
      formErrorObj["bankName"] = "This field is Required";
    }
    if (branchkName == "" || branchkName === null) {
      formErrorObj["branchkName"] = "This field is Required";
    }

    setFormErrors(formErrorObj);
    return formErrorObj;
  };

  const isFile = (input: any) => "File" in window && input instanceof File;

  const getBase64FromFilePromise = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (isFile(file) === true) {
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
      }
      reader.onerror = (error) => reject(error);
    });

  const onClickFunction = async (action: any) => {
    if (action === "Submit") {
      if (inputFields?.[0]?.files.length > 10) {
        notify(ToastType.Error, "Only 10 Files are allowed!");
        return false;
      }
      showLoader();

      let formErrorObj = onSubmitValidation();
      let isEmpty = Object.values(formErrorObj).every((f) => {
        return f === "" || f === null || f === undefined;
      });

      if (isEmpty) {
        debugger
      
        let documentId = [];
        for (let index = 0; index < files[0].files.length; index++) {
          const Document = files[0].files[index];
          let tempString = await getBase64FromFilePromise(Document?.blob);
          if (tempString && tempString !== "") {
            let param = {
              DocumentName: files[0].files[index].name,
              DocumentType: files[0].files[index].name?.split(".").pop(),
              DocumentUrl: "",
              BinaryFile: String(tempString).split("base64,")[1],
            };

            const insertData = await APICall(documentDetails2, param);
            if (insertData.Status === ApiStatus.OK && insertData?.Data) {
              documentId.push(insertData.Data);
            } else {
            
            }
          }
          //   if (isReasonDeath) {
          // }
        }

        try {
          let param = {
            // MemberName: null, //memberName,
            // Address: null, //address,
            // DOC: null, //doConfirmDate,
            // DOB: null, //doBirth,
            // EmailId: null, //emailID, //"dewoolkarchinmay361mnmcs@gmail.com",//
            // ContactNumber: null, //mobileNo,
            Comment: "",
            AccountNo: accountNumber,
            MICRCode: micrCode,
            BankName: bankName,
            BranchName: branchkName,
            MemberId: isInternalTeam ? memberId : context.MemberId,
            MemberNo: isInternalTeam ? memberNumber : context.MemberNo,
            TokenNo: tokenNumber,
            ReasonOfRequest: reasonRequest ? reasonRequest.value : "",
            DocumentDetailId: documentId.join(","),
            IsSubmittedByAdmin: isInternalTeam,
            RoleId: context.CurrentRoleId,
            CreatedBy: context.MemberId,
            ModifiedBy: context.MemberId,
          };

          const insertData2 = await APICall(SubmitSettlement, param);
          
          if (insertData2.Message === "Surety") {
            setSuretyData(insertData2?.Data);
            setSuretyModal(true);
          } else if (insertData2.Message === "Ok") {
            notify(
              ToastType.Success,
              "Settlement Request Submitted Successfully"
            );
            navigate("/SettlementRequestDashboard");
          } else if (insertData2.Message === "Exist") {
            notify(
              ToastType.Error,
              "Data Already Exist for Member No " + insertData2.Data
            );
          }
          hideLoader();
        } finally {
          hideLoader();
        }
      }
      hideLoader();
    }
  };

  const handleTextEvent = (event: any, field: any) => {
    let value = event.target.value;
    if (field === "memberNumber") {
      const regex = /^[0-9]+(\.\d{1,2})?$/;
      setIFSCCode("");
      setAccountNumber("");
      setBankName("");
      setbranchkName("");
      if (value === "" || regex.test(value)) {
        setMemberNumber(value);
      }
    }

    if (field === "accountNumber") {
      setAccountNumber(value);
    }
    if (field === "IFSCCode") {
      setIFSCCode(value);
    }
    if (field === "bankName") {
      setBankName(value);
    }
    if (field === "branchkName") {
      setbranchkName(value);
    }
  };

  const fileSelect = (event, index, fieldName) => {
    if (
      Array.from((event?.target?.files as FileList) || []).filter(
        (f) =>
          !(f?.type && (f.type.includes("image") || f.type.includes("pdf")))
      ).length > 0
    ) {
      if (inputFileRef.current) {
        inputFileRef.current.value = null;
      }
      notify(ToastType.Error, "Only images & pdf are allowed!");
      return;
    }

    const maxFileSizeMB = 2;
    
    for (let i = 0; i < event?.target?.files.length; i++) {
      const fileSizeMB = event?.target?.files[i].size / 1024 / 1024;
      if (fileSizeMB > maxFileSizeMB) {
        if (inputFileRef.current) {
          inputFileRef.current.value = null;
        }
        notify(ToastType.Error, "Please select files with size up to 2MB each");
        return false; // Return false if any file size is more than 2MB
      }
    }

    for (let i = 0; i < event?.target?.files.length; i++) {
      const fileName = event?.target?.files[i].name;
      if (SPECIALCHARPATTERN.test(fileName)) {
        // You can also display an error message to the user here
        if (inputFileRef.current) {
          inputFileRef.current.value = null;
        }
        notify(ToastType.Error,`File contains special characters. Please rename the file.`);
        return false;
      }
    }

    const allowedFileTypesArr = allowedFileTypes?.split(",");
    if (allowedFileTypesArr) {
      let isExtensionAllowed = true;
      let filesToCheck = [...event?.target?.files];
      for (let index = 0; index < filesToCheck.length; index++) {
        const fileToCheck = filesToCheck[index];
        isExtensionAllowed = allowedFileTypesArr.some((ext) =>
          fileToCheck?.name?.endsWith(ext)
        );
        if (!isExtensionAllowed) break;
      }
      if (!isExtensionAllowed) {
        notify(
          ToastType.Error,
          `Only ${allowedFileTypesArr?.join(", ")} files are allowed!`
        );
        return;
      }
    }

    if (event.target.files.length > 0) {
      let filesTmp = [];
      filesTmp = [...files];
      if (!filesTmp?.[index]) {
        filesTmp[index] = { files: [] };
      }
      let count = filesTmp[index].files?.length;
      for (let i = 0; i < event?.target?.files?.length; i++) {
        const file = event?.target?.files?.[i];
        if (file) {
          filesTmp[index].files.push({
            localUrl: URL.createObjectURL(file),
            blob: file,
            fileid: `img_${count}`,
            name: file.name,
            size: file.size,
            type: file.type,
            attachmentFileType: file.type,
          });
        }
        count++;
      }
      setCertificateName(filesTmp);
      setFiles(filesTmp);
      let data = [...inputFields];
      data[index][fieldName] = filesTmp[index].files; // event.target.files[0].name;
      setInputFields(data);
      // setCheckIsUploadedFile(true);
    }

    // Clear the input value after processing
    if (inputFileRef.current) {
      inputFileRef.current.value = null;
    }
  };

  const selectOnChange = (event: any, field: any) => {
    if (field === "reasonRequest") {
      // setFiles([]);
      // setInputFields([
      //   {
      //     files: [{}],
      //     fileIds: [],
      //     fileid: [],
      //     uploadedFileName: "",
      //     attachmentFileType: "",
      //     thumbnailId: "",
      //     videoId: "",
      //     transcriptionData: "",
      //   },
      // ]);
      setReasonRequest(event);
      if (event.label === "Death") {
        setIsReasonDeath(false);
      } else {
        if (memberNumber != null && memberNumber != "") {
          getMemberDetailsById(memberNumber);
        }
        setIsReasonDeath(true);
      }
    }
    if (field === "doConfirm") {
      setDoConfirmDate(event);
    }
    if (field === "doBirth") {
      setDoBirth(event);
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const deleteImage = async (data) => {
    showLoader();
    const { file, index } = data;
    try {
      setShowDeleteConfirmationModal(false);
      let filesTmp = [];
      let newData = [...files]?.[index]?.files.filter(
        (f: { fileid?: string }) => f?.fileid !== file.fileid
      );
      filesTmp[index] = { files: newData };
      setFiles(filesTmp);
      setInputFields(filesTmp);

      // Reset input field value

      const inputElement = document.getElementById(
        `row_${index}`
      ) as HTMLInputElement;

      if (inputElement) {
        inputElement.value = filesTmp?.[0]?.files?.length <= 0 && "";
      }
    } catch (err) {
      hideLoader();
    } finally {
      hideLoader();
    }
  };

  const handleKeyNumbers = (event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  };

  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const DocumentList = ({ documents }) => {
    const documentChunks = chunkArray(documents, 5);

    return (
      <div style={{display: "flex", flexWrap: "wrap"}}>
        {documentChunks.map((chunk, chunkIndex) => (
          <ul
            key={chunkIndex}
            style={{ listStyleType: "circle", paddingLeft: "30px" }}
          >
            {chunk.map((doc, index) => (
              <li key={index} style={{ listStyleType: "circle" }}>
                <p
                  onClick={() => {
                    if (doc?.type === "pdf") {
                      window.open(doc.src, "_blank");
                    } else {
                      setImageIndex(0);
                      setShowImageViewer(true);
                    }
                    // handleDocumentClick(doc, index + chunkIndex * 5)
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {doc.title}
                </p>
              </li>
            ))}
          </ul>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="clearfix"></div>
      <SettlementStatus
        statusId={StateCurrentStatus}
        SettlementNameModule={SettlementModule.SettlementDetails}
        rejectReasons={RejectedRemarks}
      />
      <div className="clearfix"></div>
      <div className="">
        <div className="col-lg-12 col-md-12 mt-3 p-0">
          <div className="row">
            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Member Number</label>
              </div>
            </div>

            <div
              className={
                viewmode
                  ? "col-lg-4 col-sm-4 col-xs-4"
                  : isDisable
                  ? `col-lg-4 col-sm-4 col-xs-4`
                  : `col-lg-3 col-sm-3 col-xs-3`
              }
            >
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  maxlength={30}
                  value={memberNumber}
                  onChange={(e) => handleTextEvent(e, "memberNumber")}
                  isDisabled={isDisable || viewmode}
                />

                <p style={{ color: "red" }}>
                  {formErrors["memberNumber_isEmpty"]}
                </p>
                <p></p>
              </div>
            </div>

            {!viewmode && !isDisable && (
              <div className="col-lg-1 col-sm-1 col-xs-1">
                <div className="form-group">
                  <ButtonForm
                    className="btn btn-submit"
                    style={{ marginLeft: 5 }}
                    id="search"
                    value="Search"
                    disabled={viewmode}
                    onClick={() => {
                      if (
                        memberNumber !== "" &&
                        memberNumber !== undefined &&
                        memberNumber !== null
                      ) {
                        getMemberDetailsById(memberNumber);
                      }
                    }}
                  />
                </div>
              </div>
            )}

            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Name</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={memberName}
                  onChange={(e) => handleTextEvent(e, "tokenNumber")}
                  isDisabled={true}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Token Number</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={tokenNumber}
                  onChange={(event: any) =>
                    handleTextEvent(event, "tokenNumber")
                  }
                  isDisabled={true}
                />
              </div>
            </div>

            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Residential Address</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={address}
                  textArea={true}
                  isDisabled={true}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Date of Confirmation</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
              <DateForm
                value={
                  Array.isArray(doConfirmDate)
                    ? null
                    : (doConfirmDate === '0001-01-01T00:00:00' ||
                       doConfirmDate === '01-01-0001' )
                      ? null
                      : doConfirmDate
                }
                
                onChange={(event: any) => selectOnChange(event, "doConfirm")}
                placeholder="DD-MM-YYYY"
                isDisabled={true}
              />


                {/* <DateForm
                  // disableFuture={true}
                  value={doConfirmDate}
                  onChange={(event: any) => selectOnChange(event, "doConfirm")}
                  placeholder="DD-MM-YYYY"
                  isDisabled={true}
                /> */}
              </div>
            </div>

            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Email ID</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={emailID}
                  onChange={(event: any) => handleTextEvent(event, "emailID")}
                  isDisabled={true}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Date of Birth</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <DateForm
                  // disableFuture={true}
                  //value={doBirth}
                  value={
                    Array.isArray(doBirth)
                      ? null
                      : (doBirth === '0001-01-01T00:00:00' ||
                        doBirth === '01-01-0001' )
                        ? null
                        : doBirth
                  }
                  onChange={(event: any) => selectOnChange(event, "doBirth")}
                  placeholder="DD-MM-YYYY"
                  isDisabled={true}
                />
              </div>
            </div>

            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Reason of Request</label>
              </div>
            </div>

            <div className="col-lg-4 col-sm-4 col-xs-4">
              <SelectForm
                options={reasonArrayOptions}
                isMulti={false}
                placeholder={"Select Reason of Request"}
                value={reasonRequest}
                isDisabled={viewmode}
                onChange={(event: any) =>
                  selectOnChange(event, "reasonRequest")
                }
              />
              <p style={{ color: "red" }}>
                {formErrors["reasonRequest_isEmpty"]}
              </p>
            </div>
          </div>
          {!viewmode && (
            <>
              <div className="row">
                {inputFields.map((input, index) => {
                  // let bulkUploadStatuss =
                  //   input.bulkUploadStatus == 0 ||
                  //   input.bulkUploadStatus == 2 ||
                  //   input.bulkUploadStatus == null;
                  // let bulkUploadStatusswithoutnull =
                  //   input.bulkUploadStatus == 0 || input.bulkUploadStatus == 2;

                  return (
                    <>
                      <div className="col-lg-2 col-sm-2 col-xs-2">
                        <div className="form-group">
                          <label className="form-check-label">
                            Upload File <sup>*</sup>
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-4 col-sm-4 col-xs-4 ">
                        <div className="form-group">
                          <input
                            className="form-control inputfile inputfile-6"
                            name={`row_${index}`}
                            data-index={index}
                            id={`row_${index}`}
                            type="file"
                            ref={inputFileRef}
                            onChange={(event) => {
                              fileSelect(event, index, "files");
                            }}
                            multiple={true}
                            // disabled={false}
                          />

                          <label
                            htmlFor="file-8-uploadPan"
                            className="form-control"
                            style={{ border: "none" }}
                            onClick={handleBtnClick}
                          >
                            <span style={{ float: "right" }}>
                              {inputFields?.[0]?.files.length > 1
                                ? inputFields?.[0]?.files?.length + " files"
                                : ""}
                              {inputFields?.[0]?.files.length > 10 && (
                                <span style={{ color: "red" }}>
                                  Max 10 files allowed
                                </span>
                              )}
                            </span>
                            <strong
                              style={{
                                width: "30%",
                                left: "0",
                                borderTopRightRadius: "0",
                                borderBottomRightRadius: "0",
                              }}
                            >
                              <i className="far fa-file"></i> Browse
                            </strong>{" "}
                          </label>
                        </div>
                        <p style={{ color: "red" }}>
                          {formErrors["file_isEmpty"]}
                        </p>
                      </div>
                    </>
                  );
                })}
              </div>
            </>
          )}
          <div className="row">
            <div className="col-lg-2 col-sm-2 col-xs-2"></div>
            {inputFields.map((input, index) => {
              const fileChunks = chunkArray(input?.files || [], 5);
              let count = 0; // Initialize count outside of the map function
              return (
                <>
                  {fileChunks.map((chunk, chunkIndex) => {
                    return (
                      <ul key={chunkIndex}>
                        {chunk.map((value, index2) => {
                          count++; // Increment count for each item
                          return (
                            <ShowAttachment
                              key={index2}
                              editMode={false}
                              aType={value?.attachmentFileType}
                              attachment={value?.file || value}
                              thumbnailId={value?.thumbnailId}
                              fIdx={index2}
                              index={index}
                              setFileToBeDeleted={setFileToBeDeleted}
                              setShowDeleteConfirmationModal={
                                setShowDeleteConfirmationModal
                              }
                              count={count} // Pass count as a prop to ShowAttachment
                            />
                          );
                        })}
                      </ul>
                    );
                  })}
                </>
              );
            })}
            {/* <ul className="list-unstyled">
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                {inputFields.map((input, index) => {
                  return (
                    <>
                      {input?.files?.map((value: any, index2: any) => {
                        return (
                          <ShowAttachment
                            key={index2}
                            editMode={false}
                            aType={value?.attachmentFileType}
                            attachment={value?.file || value}
                            thumbnailId={value?.thumbnailId}
                            fIdx={index2}
                            index={index}
                            setFileToBeDeleted={setFileToBeDeleted}
                            setShowDeleteConfirmationModal={
                              setShowDeleteConfirmationModal
                            }
                          />
                        );
                      })}
                    </>
                  );
                })}
              </div>
            </ul> */}
          </div>

          <div className="row">
            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Saving Bank Account Number</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={accountNumber}
                  onChange={(event: any) =>
                    handleTextEvent(event, "accountNumber")
                  }
                  isDisabled={isReasonDeath}
                  // onKeyPress={handleKeyNumbers}
                  maxlength={20}
                />
              </div>
              <p style={{ color: "red" }}>{formErrors["accountNumber"]}</p>
            </div>

            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>MICR Code</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={micrCode}
                  isDisabled={true}
                />
              </div>
              {formErrors["micrCode"]}
            </div>

            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>IFSC Code</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={IFSCCode}
                  isDisabled={isReasonDeath}
                  onChange={(event: any) => {
                    let value = event.target.value;

                    // const regex = /^[A-Za-z]{4}\d{7}$/;
                    const regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
                    if (!regex.test(value)) {
                      setError({
                        ...error,
                        ["IFSCCode"]: "Please enter a valid IFSC number.",
                      });
                    } else {
                      setError({ ...error, ["IFSCCode"]: "" });
                    }
                    handleTextEvent(event, "IFSCCode");
                  }}
                />
              </div>
              <p style={{ color: "red" }}>{formErrors["IFSCCode"]}</p>
            </div>
            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Bank Name</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={bankName}
                  isDisabled={isReasonDeath}
                  onChange={(event: any) => handleTextEvent(event, "bankName")}
                />
                <p style={{ color: "red" }}>{formErrors["bankName"]}</p>
              </div>
            </div>

            <div className="col-lg-2 col-sm-2 col-xs-2">
              <div className="form-group">
                <label>Branch Name</label>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={branchkName}
                  isDisabled={isReasonDeath}
                  onChange={(event: any) =>
                    handleTextEvent(event, "branchkName")
                  }
                />
              </div>
              <p style={{ color: "red" }}>{formErrors["branchkName"]}</p>
            </div>
            {documents?.length > 0 && (
              <div className="col-lg-2 col-sm-2 col-xs-2">
                <div className="form-group">
                  <label>Attached Documents</label>
                </div>
              </div>
            )}
            <div className="col-lg-4 col-sm-4 col-xs-4">
              {documents?.length > 0 && (
                <>
                  <DocumentList
                    documents={documents}
                  />
                  {/* <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    {documents.map((doc, index) => (
                      <li key={index} style={{ listStyleType: "circle" }}>
                        <p
                          onClick={() => handleDocumentClick(doc, index)}
                          style={{ cursor: "pointer" }}
                        >
                          {doc.title}
                        </p>
                      </li>
                    ))}
                  </ul> */}

                  {showImageViewer && (
                    <ImageViewer
                      open={showImageViewer}
                      images={documents.filter((doc) => doc?.type === "image")}
                      imageIndex={imageIndex}
                      onClose={() => {
                        setShowImageViewer(false);
                        setImageIndex(null);
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </div>
          {!viewmode && (
            <div>
              <input
                // autoComplete={AutoCompleteValue}
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <span>
                {"  "}I here by certify that the particulars given above are
                true.
              </span>
            </div>
          )}
          <div className="d-flex CenterDiv justify-content-between">
            <div>
              <ButtonForm
                className="btn btn-primary"
                style={{ marginLeft: 5 }}
                id="Cancel"
                value="Cancel"
                onClick={() => navigate("/SettlementRequestDashboard")}
              />
              {!viewmode && (
                <>
                  <ButtonComponent
                    icon="fas fa-paper-plane"
                    className="btn btn-submit"
                    style={{ marginLeft: 5 }}
                    id="submit"
                    value="Submit"
                    onClick={() => onClickFunction("Submit")}
                    disabled={!isChecked}
                  />
                </>
              )}
            </div>
          </div>

          {/* {viewmode && isInternalTeam && (
            <>
              <div className="d-flex justify-content-center mt-5 ">
                <div className="">
                  <ButtonForm
                    className="btn btn-submit"
                    style={{ marginLeft: 5 }}
                    id="submit"
                    value="Approve"
                    // onClick={() => onClickFunction("Submit")}
                    // disabled={!isChecked || submitDisable}
                  />
                </div>
                <div className="">
                  <ButtonForm
                    className="btn btn-primary"
                    style={{ marginLeft: 5 }}
                    id="reject"
                    value="Reject"
                    // onClick={() => onClickFunction("Submit")}
                    // disabled={!isChecked || submitDisable}
                  />
                </div>
              </div>
            </>
          )} */}
        </div>
      </div>
      <DeleteDialogueBox
        open={showDeleteConfirmationModal}
        close={() => setShowDeleteConfirmationModal(false)}
        cancel={() => {
          setFileToBeDeleted({});
          setShowDeleteConfirmationModal(false);
        }}
        deleteImage={() => deleteImage(fileToBeDeleted)}
      />

      <Modal
        centered
        show={suretyModal}
        onHide={() => {
          setSuretyModal(false);
        }}
        style={{ backgroundColor: "rgba(255, 255, 255, 0.75)" }}
      >
        <Modal.Header className="custom-modal-header" closeButton>
          <Modal.Title className="text-center">Request Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div className="form-group">
              <label>
                As you are surety for below mention member {suretyData}, you
                cannot proceed.
              </label>

              <label>Please remove yourself as Surety and try again.</label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex  justify-content-between">
            <div>
              <ButtonComponent
                className="btn btn-submit"
                style={{
                  marginLeft: 5,
                  cursor: "pointer",
                }}
                icon={""}
                value={"Surety Details"}
                onClick={() => {
                  navigate("/SuretyMemberView", { state: { memberId } });
                }}
              />
              <ButtonComponent
                className="btn btn-dark"
                style={{
                  marginLeft: 5,
                  cursor: "pointer",
                }}
                icon={""}
                value={"Back"}
                onClick={() => {
                  setSuretyModal(false);
                }}
              />
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FinalSettlement;
